module.exports = __webpack_public_path__ + "static/media/wild-gypsy.e66a3978.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/wild-gypsy.png
// module id = 1366
// module chunks = 1